/* VELA Co. theme behaviors */
(function(){
  'use strict';

  /* reveals */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.08});
    document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function(el){ el.classList.add('in'); });
  }

  /* apothecary index: hover peek follows the cursor */
  var list = document.getElementById('idxlist');
  if (list && matchMedia('(pointer:fine)').matches) {
    var peek = document.createElement('img');
    peek.className = 'peek';
    peek.alt = '';
    document.body.appendChild(peek);
    list.querySelectorAll('.row[data-img]').forEach(function(row){
      row.addEventListener('mouseenter', function(){ peek.src = row.dataset.img; peek.classList.add('on'); });
      row.addEventListener('mouseleave', function(){ peek.classList.remove('on'); });
      row.addEventListener('mousemove', function(ev){
        peek.style.left = ev.clientX + 'px';
        peek.style.top  = ev.clientY + 'px';
      });
    });
  }

  /* mini door opens as the CTA arrives */
  var md = document.getElementById('minidoor');
  if (md && 'IntersectionObserver' in window) {
    var dio = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ setTimeout(function(){ md.classList.add('open'); }, 500); dio.disconnect(); } });
    }, {threshold:.6});
    dio.observe(md);
  }

  /* rotating quotes */
  var qwrap = document.getElementById('VelaQuotes');
  if (qwrap) {
    var qs = qwrap.querySelectorAll('.q');
    if (qs.length > 1) {
      var qi = 0;
      setInterval(function(){
        qs[qi].classList.remove('on');
        qi = (qi + 1) % qs.length;
        qs[qi].classList.add('on');
      }, 6500);
    }
  }

  /* referral code copy */
  var copyBtn = document.getElementById('VelaRefCopy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function(){
      var code = document.getElementById('VelaRefCode');
      if (!code) return;
      var done = function(){
        var t = copyBtn.textContent;
        copyBtn.textContent = copyBtn.dataset.copied || 'Copied';
        setTimeout(function(){ copyBtn.textContent = t; }, 1800);
      };
      if (navigator.clipboard) { navigator.clipboard.writeText(code.textContent.trim()).then(done); }
      else {
        var r = document.createRange(); r.selectNode(code);
        var s = getSelection(); s.removeAllRanges(); s.addRange(r);
        try { document.execCommand('copy'); done(); } catch(e){}
        s.removeAllRanges();
      }
    });
  }
})();
